import { useState } from "react";
import { AssetGeoLocation } from "../models/asset";
import { fetchAssetGeoLocation } from "../api/fetchAssets";

function useAssetGeoLocation() {
    const [assetGeoLocation, setAssetGeoLocation] = useState<AssetGeoLocation | undefined>(undefined);

    const getAssetGeoLocation = async (assetId?: string): Promise<AssetGeoLocation | undefined> => {
        if(assetId) {
            const data = await fetchAssetGeoLocation(assetId);
            setAssetGeoLocation(data ?? undefined);
            return data ?? undefined;
        }
        return undefined;
    }

    return { assetGeoLocation, getAssetGeoLocation }
}

export default useAssetGeoLocation;